import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=e47bd184&scoped=true&"
import script from "./CommentForm.vue?vue&type=script&lang=js&"
export * from "./CommentForm.vue?vue&type=script&lang=js&"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=e47bd184&scoped=true&lang=sass&"
import style1 from "./CommentForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47bd184",
  null
  
)

export default component.exports